"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__753a01d0a",
  width: 16,
  height: 16,
  x: 0,
  y: 0
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h16v16H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm-.001 2.95A1.8 1.8 0 0 0 6.19 6.74a.65.65 0 0 0 1.3 0A.5.5 0 0 1 8 6.25a.5.5 0 0 1 .508.491c0 .077-.02.118-.048.156a.942.942 0 0 1-.234.196c-.333.22-.877.642-.877 1.455v.142a.65.65 0 0 0 1.3 0v-.142c0-.082.021-.127.052-.167a.977.977 0 0 1 .243-.204c.325-.216.864-.633.864-1.436a1.8 1.8 0 0 0-1.808-1.79ZM8 11.3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
  clipRule: "evenodd",
  mask: "url(#ursa-icon__753a01d0a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HelpFillIcon16.js.map